"use strict";

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompileError = void 0;

var colors_1 = __importDefault(require("colors"));

var error_1 = __importDefault(require("@truffle/error"));

var CompileError = /*#__PURE__*/function (_error_1$default) {
  _inherits(CompileError, _error_1$default);

  var _super = _createSuper(CompileError);

  function CompileError(message) {
    var _this;

    _classCallCheck(this, CompileError);

    // Note we trim() because solc likes to add extra whitespace.
    var fancy_message = message.trim() + "\n\n" + colors_1.default.red("Compilation failed. See above.");
    var normal_message = message.trim();
    _this = _super.call(this, normal_message);
    _this.message = fancy_message; //?? I don't understand this, I just found it here

    return _this;
  }

  return _createClass(CompileError);
}(error_1.default);

exports.CompileError = CompileError;